<app-list-of-products (productEmitter)="onProductClick($event)" [productListInput]="signalProductList()"
    [productResourceRef]="store.computedProductResource()"></app-list-of-products>